import { format, parseISO, isValid } from 'date-fns';

export function convertDateTime(utcDateTime: string): string {
  let text = 'N/A';

  if (utcDateTime && isValid(parseISO(utcDateTime))) {
    const parsedTime = parseISO(utcDateTime);
    text = format(new Date(parsedTime), 'dd-MMM-yyyy HH:mm:ss');
  }

  return text;
}

export function convertDate(utcDateTime: string): string {
  let text = 'N/A';

  if (utcDateTime && isValid(parseISO(utcDateTime))) {
    const parsedTime = parseISO(utcDateTime);
    text = format(new Date(parsedTime), 'dd-MMM-yyyy');
  }

  return text;
}

export function convertTime(utcDateTime: string | null): string {
  let text = 'N/A';
  if (utcDateTime === null) return text;

  if (utcDateTime && isValid(parseISO(utcDateTime))) {
    const parsedTime = parseISO(utcDateTime);
    text = format(new Date(parsedTime), 'HH:mm:ss');
  }

  return text;
}

export function formatDateTime(dateTimeString: string) {
  if (dateTimeString === 'ERROR') return 'ERROR';

  // Parse the input string
  let year = Number(dateTimeString.slice(0, 4));
  let month = Number(dateTimeString.slice(4, 6));
  let day = Number(dateTimeString.slice(6, 8));
  let hour = Number(dateTimeString.slice(8, 10));
  let minute = Number(dateTimeString.slice(10, 12));
  let second = Number(dateTimeString.slice(12, 14));

  // Create a new Date object
  let date = new Date(year, month - 1, day, hour, minute, second);

  // Format the date and time
  let options = { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false };
  // @ts-ignore
  return date.toLocaleString('en-GB', options).replace(' ', '-').replace(' ', '-').replace(',', '');
}

export function convertToISOTime(date: string, time: string) {
  return new Date(`${date} ${time}`).toISOString();
}
